import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { BotsCreators } from '../../store/actions/bots';
import { UserActions } from '../../store/actions/users';
import Footer from '../../components/Footer2';

import Header from '../../components/Header';
import Box from './Box';
import BoxNewBot from './BoxNewBot';
import Search from './Search';

import { LoadingText } from './styles';

function normalized(string) {
  return string
    ?.normalize('NFD')
    ?.replace(/[\u0300-\u036f]/g, '')
    ?.toLocaleLowerCase()
    ?.trim();
}

class Bots extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: '',
    };
  }

  componentDidMount() {
    const { me, bots, signedUser, listBotsRequest } = this.props;
    if (!signedUser) {
      me();
    }
    if (signedUser) {
      listBotsRequest();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.signedUser !== this.props.signedUser) {
      const { listBotsRequest } = this.props;

      listBotsRequest();
    }
  }

  handleSearchOnChange = (event) => {
    this.setState({
      search: event.target.value,
    });
  };

  isAuthorizedUser = () => {
    const { signedUser } = this.props;
    return signedUser?.selectedCompany?.claim?.name !== 'Viewer';
  };

  handleCreateChatBot = () => {
    const { newBotRequest, signedUser } = this.props;
    const { selectedOrganization: organizationId } = signedUser;
    const companyId = signedUser.selectedCompany._id;

    if (this.isAuthorizedUser) {
      newBotRequest({
        title: 'Novo Bot',
        type: 'chat',
        companyId,
        organizationId,
      });
    }
  };

  render() {
    const { list, loading } = this.props.bots;
    const search = normalized(this.state.search);

    const searchResults = [];

    if ('criar novo bot'.includes(search))
      searchResults.push(
        <BoxNewBot
          handleCreateChatBot={this.handleCreateChatBot}
          key="new-bot"
        />
      );

    for (const bot of list || []) {
      if (
        normalized(bot.title)?.includes(search) ||
        normalized(bot.description)?.includes(search)
      )
        searchResults.push(
          <Box
            key={bot._id}
            id={bot._id}
            img={bot.img}
            title={bot.title}
            description={bot.description}
            type={bot.type}
          />
        );
    }

    return (
      <Fragment>
        <Header pagetype="page-inicio" />
        <div className="linha-conteudo-bot">
          {loading && (
            <div>
              <LoadingText>Carregando...</LoadingText>
            </div>
          )}

          <Search
            value={this.state.search}
            onChange={this.handleSearchOnChange}
          />
          <div
            className="col-md-12 conteudo-iniciar "
            style={{ paddingTop: 0, marginBottom: '1rem' }}
          >
            {searchResults}
            {searchResults.length === 0 ? 'Nenhum resultado' : null}
          </div>
        </div>
        <Footer />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  bots: state.bots,
  signedUser: state.users.signedUser,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...BotsCreators, ...UserActions }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Bots);
